import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAccessToken } from '../../services/auth.api';
import { setLoggedInUser } from '../../features/User/userSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { Col, Container, Row } from 'react-bootstrap';
import useAuth from '../../context/AuthContext';

  const AuthCallback = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { authSetToken } = useAuth();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (loading) {
        setLoading(false);
        navigate('/');
      }
    }, 10000);
    return () => clearTimeout(timeout);
  }, [loading, navigate]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    const code = urlParams.get('code');
    const userState = urlParams.get('userState');
    const codeVerifier = localStorage.getItem('code_verifier');

    if (code) {
      localStorage.setItem('code', code);
    }

    if (!code) {
      setLoading(false);
      navigate('/');
      return;
    }

    if (!codeVerifier) {
      setLoading(false);
      navigate('/?passwordReset=true');
      return;
    }

    if (userState === 'Authenticated' || userState === 'AuthenticatedNotRegistered') {
      getAccessToken(code, codeVerifier)
        .then((user) => {
          const token = localStorage.getItem("access_token") as string;
          authSetToken(token);
          setLoading(false);
          dispatch(setLoggedInUser(user));
          navigate('/home');
        })
        .catch(() => {
          setLoading(false);
          navigate('/?passwordReset=true');
        });
    } else {
      setLoading(false);
      navigate('/?passwordReset=true');
    }
  }, []);

  return (
      <>
         <main className="container-fluid errorPage-bg">
         <Container fluid className="vh-100 d-flex justify-content-center align-items-center">
            <Row>
                <Col className="text-center">
                   <h2>Redirecting...</h2>
                </Col>
            </Row>
        </Container>
      </main>
      </>
  ) 
};

export default AuthCallback;
